import { t } from '@lingui/macro'

import { ErrorLayout } from '@/modules/shared/components/error-layout/ErrorLayout'

export function IntramurosExpiredError() {
  return (
    <ErrorLayout
      title={t({
        id: 'errors.intramuros-expired.title',
        message: 'De toegang tot de agenda van de patiënt is niet meer geldig',
      })}
      message={t({
        id: 'errors.intramuros-expired.body',
        message:
          'De link die je gebruikte is slechts voor beperkte tijd bruikbaar. Ga terug naar het dossier van de patiënt om opnieuw een link te genereren.',
      })}
      imgSrc='/img/svg/timeline-error.svg'
    />
  )
}
